import React from 'react'
import type { BetSlipWorkflowState } from './Store/Workflow'
import type { globalToastEmitter } from '@mobi/component-library/Feedback/Toast/helpers/events'

// Global

export interface BetSlipGlobalContext {
  registeredInvestmentInputsRef: React.MutableRefObject<
    NonNullable<BetSlipWorkflowState['activeInvestment']>[]
  >
  toastEmitter: typeof globalToastEmitter
}
export const BetSlipContext = React.createContext<BetSlipGlobalContext | undefined>(undefined)

// Share Bet

type IsShareActiveContext = boolean
export const ShareBetContext = React.createContext<IsShareActiveContext>(false)
